export default {
    signedInUser: null,
    localStorageAuthTokenName: 'signIn.DMReferenceProjectSyncFusionVue',
};
